import { fetchJSON } from "@/api/utils.js";

export async function fetchHistory(target_class, target_id) {
  const url = "/api/history/object";
  const resp = await fetchJSON(
    url,
    {
      target_class,
      target_id,
    },
    null,
    "get",
    false
  );
  return resp.data;
}
